export const TIMEZONES = [
  { label: 'Alaska Time', value: 'America/Juneau' },
  { label: 'Arizona Time', value: 'America/Phoenix' },
  { label: 'Central Time', value: 'America/Chicago' },
  { label: 'Eastern Time', value: 'America/New_York' },
  { label: 'Hawaii Time', value: 'Pacific/Honolulu' },
  { label: 'Mountain Time', value: 'America/Denver' },
  { label: 'Pacific Time', value: 'America/Los_Angeles' },
];
